const slugifyAnchor = (value = "") => {
    const slug = String(value)
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");

    if (!slug) {
        return "";
    }

    return /^\d/.test(slug) ? `section-${slug}` : slug;
};

export default slugifyAnchor;
